var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DefaultUrlSerializer } from '@angular/router';
var LowerCaseUrlSerializerService = /** @class */ (function (_super) {
    __extends(LowerCaseUrlSerializerService, _super);
    function LowerCaseUrlSerializerService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LowerCaseUrlSerializerService.prototype.parse = function (url) {
        return _super.prototype.parse.call(this, url.toLowerCase());
    };
    return LowerCaseUrlSerializerService;
}(DefaultUrlSerializer));
export { LowerCaseUrlSerializerService };
